import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  homeURL,
  privacypolicyURL,
  termsandconditionURL,
  thankyouURL,
  winnersURL,
} from "./helpers/paths";
import NotFound from "./pages/NotFound/NotFound";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Loader from "./components/Loader/Loader";
import ThankyouV1 from "./pages/ThankyouV1/ThankyouV1";
import Winners from "./pages/Winners/Winners";

const Home = lazy(() => import("./pages/Homepage/Homepage"));

const Routing = () => {
  return (
    <>
      <Header />
      <Suspense fallback={<Loader />}>
        <div className="content_box">
          <Routes>
            <Route path={homeURL} element={<Home />} />
            {/* <Route
              path={termsandconditionURL}
              element={<TermsAndConditions />}
            /> */}
            <Route path={privacypolicyURL} element={<PrivacyPolicy />} />
            <Route path={winnersURL} element={<Winners />} />
            <Route path={thankyouURL} element={<ThankyouV1 />} />
            <Route exact path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" />} />
          </Routes>
        </div>
      </Suspense>
      <Footer />
    </>
  );
};

export default Routing;
